<template>
  <div id="map" style="height: 100%;">
    <v-bottom-sheet v-model="dialog" hide-overlay inset>
      <v-card>
        <v-card-title>
          Informações
          <v-spacer />
          <v-btn icon @click="dialog = !dialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-tabs v-model="tab">
          <v-tab
            v-for="item in items()"
            :key="item.tab"
            class="text-none"
          >
            {{ item.tab }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" tile>
          <v-tab-item
            v-for="item in items()"
            :key="item.tab"
          >
            <v-data-table
              :headers="item.headers"
              :items="item.items"
              :itemsPerPage="5"
              :loading="loading"
            >
            <template #item.link="{ value }">
              <a v-if="value != '-'" target="_blank" :href="value">LINK</a>
              <a v-else > - </a>
            </template>

            <template #item.link_port="{ value }">
              <a v-if="value != '-'" target="_blank" :href="value">LINK</a>
              <a v-else > - </a>
            </template>

        </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import store from '@/store/store.js'
import axios from 'axios'
import * as L from 'leaflet'
//import wms from 'leaflet.wms'
import { templates } from '@/domain/templates'

import { createBaseLayers } from '@/domain/library'
//import { createGroupedOverlays } from '@/domain/layers'
import { createMeasure } from '@/domain/library'
import { createLegend } from '@/domain/library'
import { getFeatureInfoUrl } from '@/domain/library'
import { mousePosition } from '@/domain/library'

// Custom Controls
import { homeExtent } from '@/domain/library'
import { getBounds } from '@/domain/library'

export default {
  name: 'Mapa',
  data: () => ({
    loading: false,
    dialog: false,
    tab: null,
    templates: templates(store.getters.isAuthenticated)
  }),
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.onResize()
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.map = L.map('map', {
        maxZoom: 17,
        zoomControl: false
      })
      /* .setView([-24.616440, -51.321571], 8) */

      this.map.fitBounds(getBounds())
      //this.templates = template(store.getters.isAuthenticated)

      L.control.zoom({
        zoomInTitle: 'Aproximar',
        zoomOutTitle: 'Afastar'
      }).addTo(this.map)

      L.Control.geocoder({
        position: "topleft",
        placeholder: "Pesquisar..."
      }).addTo(this.map)

      L.control.scale({
        imperial: false
      }).addTo(this.map)

      // https://stackoverflow.com/questions/54441260/how-to-prevent-leaflet-map-resizing-on-zoom-in-vue-vuetify-app
      L.Control.include({
        _refocusOnMap: L.Util.falseFn // Do nothing.
      })

      //this.$store.commit('setMap', this.map)

      // Marcadores Coloridos:
      // https://github.com/pointhi/leaflet-color-markers

      /*
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }).addTo(this.map)
      */

      var baseLayers = createBaseLayers(this.map)

      L.control.layers(baseLayers).addTo(this.map)

      var group = L.featureGroup().addTo(this.map)

      //      console.log(templates)
      //if (store.getters.isAuthenticated) {
     //   this.templates = templates
      //}  

      this.map.on('click', (e) => {
        var layers = []
        for(var layer of group.getLayers()){
          layers.push(layer.options.layers)
        }
        var url = getFeatureInfoUrl(this.map, layers, e.latlng)
        axios.get(url)
        .then(response => {
          if (response.data.features.length != 0) {
            var showDialog = false
            for (const temp of this.templates) {              
              temp.items = []
            }
            //console.log('headers: ' + response.data.features)
            for (const feature of response.data.features) {              
              for (const temp of this.templates) {
                if (feature.id.startsWith(temp.layer)) {
                  showDialog = true
                  for(var i in feature.properties) {
                    feature.properties[i] = feature.properties[i] ?? "-"
                  }
                  temp.items.push(feature.properties)
                }
              }
            }
            if (showDialog) {
              this.dialog = true
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
      })

      /*var Source = wms.Source.extend({
        parseFeatureInfo: function (result) { // url
          var json = JSON.parse(result)
          return json.features
        },
        showFeatureInfo: (latlng, info) => {
          if (info.length != 0) {
            var showDialog = false
            for (const temp of this.templates) {
              temp.items = []
            }
            for (const feature of info) {
              for (const temp of this.templates) {
                if (feature.id.startsWith(temp.layer)) {
                  showDialog = true
                  temp.items.push(feature.properties)
                }
              }
            }
            if (showDialog) {
              this.dialog = true
            }
          }
        }
      })*/

      /*var source = new Source(process.env.VUE_APP_GEOSERVER, {
        format: 'image/png',
        info_format: 'application/json',
        transparent: true,
        tiled: true,
        feature_count: 500
      })*/

      //var groupedOverlays = createGroupedOverlays(source)

      /*L.control.groupedLayers(baseLayers, groupedOverlays, {
        //autoZIndex: false
        //collapsed: (this.$vuetify.breakpoint.width < 640 && this.$vuetify.breakpoint.height < 960) //se a tela for pequena deixa em icone o quadro
      }).addTo(this.map)*/

      try {
        homeExtent().addTo(this.map)
      } catch (e) {
        console.log(e)
      }

      mousePosition(this.map) // Posição do Mouse

      /*
      L.control.layers(baseLayers, overlays, {
        collapsed: false
      }).addTo(this.map)
      */

      createMeasure(this.map) // Medir Distância
      //browserPrint().addTo(this.map) // Imprimir Mapa

      createLegend(this.map, group)

      this.$root.$on('addWmsLayer', (wmsLayer, fnc, semFeatureInfo) => {
        if(wmsLayer) {
          if(semFeatureInfo) {
            wmsLayer.addTo(this.map)
          } else {
            wmsLayer.addTo(group)
          }
          if(fnc) {
            fnc()
          }
        }
      })

      this.$root.$on('removeWmsLayer', (wmsLayer) => {
        if(wmsLayer) {
          wmsLayer.removeFrom(group)
          wmsLayer.removeFrom(this.map)
        }
      })

      this.$root.$on('addGeoJson', (geojson) => {
        if(geojson) {
          this.map.addLayer(geojson)
          this.map.fitBounds(geojson.getBounds())
        }
        if(this.$route.path != "/") {
          this.$router.push('/')
        }
      })

      this.$root.$on('removeGeoJson', (geojson) => {
        if(geojson){
          this.map.removeLayer(geojson)
        }
      })

      this.$root.$on('fitBounds', (bounds) => {
        this.map.fitBounds(bounds)
      })

      this.$root.$on('cqlFilter', (name, title, cql_filter) => {
        var params = {
          service: 'wfs',
          version: '2.0.0',
          outputFormat: 'application/json',
          exceptions: 'application/json',
          request: 'GetFeature',
          typeNames: name,
          srsName: 'EPSG:4674'
        }

        if (cql_filter) {
          params.cql_filter = cql_filter
        }

        axios.get(process.env.VUE_APP_GEOSERVER, {
          params: params
        })
          .then(response => {
            this.geojson = L.geoJson(response.data, {
              pointToLayer: function (feature, latlng) {
                return L.circleMarker(latlng, {
                  radius: 6
                })
              }
            }).addTo(this.map)

            this.map.fitBounds(this.geojson.getBounds())
          })
          .catch(error => {
            console.log(error)
          })
      })
      
      this.$root.$emit('initialLayer')
    })
  },
  methods: {
    onResize () {
      if (this.map) {
        this.map.invalidateSize()
      }
    },
    items () {
      var items = []
      for (const temp of this.templates) {
        if (temp.items.length != 0) {       
          items.push(temp)
        }
      }
      return items
    }
  }
}
</script>
